import { Backdrop, CircularProgress } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { clearStorage } from '../../../redux/actions/auth'

function Clear() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(clearStorage())
  }, [])

  return (
    <>
      <Backdrop sx={theme => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}

export default Clear
